import type { PowerPerformanceForms } from '../../../../types/mutual-fund-detail.types'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { FundCardBorderVariant, FundCardLayout } from './FundCardLayout'
import { SaveTaxBookingRow } from './SaveTaxBookingRow'

type EligibleFundProps = {
  fundLogo: string
  fundTitle: string
  fundNature: string
  fundCategory: string
  amount: number
  powerRank: number
  powerRating?: `${PowerPerformanceForms}`
  isRegular: boolean
  saveTaxAmount?: number
  isFutureTax?: boolean
  isGains?: boolean
  isLast: boolean
  onClick?: () => void
}

export function EligibleFund({
  fundLogo,
  fundTitle,
  fundNature,
  fundCategory,
  amount,
  powerRank,
  powerRating,
  isRegular,
  saveTaxAmount,
  isFutureTax = true,
  isGains = true,
  isLast,
  onClick
}: EligibleFundProps) {
  const hasSaveTaxBooking = (saveTaxAmount ?? 0) !== 0 && amount !== 0
  const taxLabel = isFutureTax ? 'future tax' : 'tax'
  const gainLossLabel = isGains ? 'gains' : 'losses'

  return (
    <FundCardLayout
      fundLogo={fundLogo}
      fundTitle={fundTitle}
      fundNature={fundNature}
      fundCategory={fundCategory}
      trailingContent={onClick != null ? <ChevronRight /> : undefined}
      trailingContentAlign="start"
      powerRank={powerRank}
      powerRating={powerRating}
      isRegular={isRegular}
      helperRows={
        hasSaveTaxBooking
          ? [
            <div>
              <SaveTaxBookingRow
                key="save-tax-booking"
                saveTaxAmount={saveTaxAmount ?? 0}
                bookAmount={Math.abs(amount)}
                taxLabel={taxLabel}
                gainLossLabel={gainLossLabel}
              />
            </div>
          ]
          : undefined
      }
      onClick={onClick}
      borderVariant={isLast ? FundCardBorderVariant.NO_BORDER : FundCardBorderVariant.BOTTOM_HALF}
      leftPadding={20}
      rightPadding={20}
    />
  )
}


export function ChevronRight() {
  return (
    <div className="mt-2">
      <RenderHTML innerHTMLText={ChevronRightSvg} />
    </div>
  )
}


export const ChevronRightSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_72847_1136)">
    <path d="M10.5012 5.73519L4.76118 0.275189C4.66061 0.179587 4.5422 0.104729 4.4127 0.0548888C4.28321 0.00504879 4.14516 -0.0187969 4.00645 -0.0152869C3.86774 -0.0117768 3.73107 0.0190203 3.60426 0.075346C3.47745 0.131672 3.36298 0.212423 3.26738 0.312989C3.0743 0.516092 2.96981 0.787576 2.9769 1.06772C2.98399 1.34786 3.10207 1.61371 3.30518 1.80679L8.50198 6.74179C8.53647 6.77437 8.56394 6.81365 8.58272 6.85722C8.6015 6.9008 8.61118 6.94774 8.61118 6.99519C8.61118 7.04264 8.6015 7.08958 8.58272 7.13315C8.56394 7.17673 8.53647 7.21601 8.50198 7.24859L3.30518 12.1836C3.10319 12.3754 2.98566 12.6395 2.97844 12.918C2.97122 13.1964 3.0749 13.4663 3.26668 13.6683C3.45846 13.8703 3.72262 13.9878 4.00105 13.995C4.27949 14.0023 4.54939 13.8986 4.75138 13.7068L10.5152 8.23279C10.6792 8.06839 10.809 7.87313 10.8971 7.65829C10.9853 7.44345 11.03 7.21328 11.0287 6.98107C11.0274 6.74886 10.9801 6.51921 10.8895 6.30537C10.799 6.09153 10.667 5.89774 10.5012 5.73519Z" fill="#8E9393"/>
  </g>
  <defs>
    <clipPath id="clip0_72847_1136">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`
